import { createFileRoute } from '@tanstack/react-router';
import PublicLayout from '@components/layout/PublicLayout';
import QuickOrderAction from '@features/quick-order-action/QuickOrderAction';

export const Route = createFileRoute('/order-action/$code/reject')({
  component: RouteComponent,
});

function RouteComponent() {
  const { code } = Route.useParams();

  return (
    <PublicLayout>
      <QuickOrderAction code={code} autoAction="reject" />
    </PublicLayout>
  );
}
